import {
  CUSTOM_ACCESS_RESOURCES_PROHIBITED_ROLES,
  CustomAccessResorces,
} from 'constants/customAccessResources';
import { Resources } from 'constants/resources';

import { useContext, useEffect } from 'react';

import { APIContext } from 'context/apiContext';
import { usePermissions } from 'hooks/usePermissions';
import { MENU_LIST } from 'layouts/components/Menu/constants/menuList';
import { useRedirect } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { Permission } from 'types/embedded/permission';

export function usePermissionRedirect() {
  const redirect = useRedirect();
  const { pathname } = useLocation();
  const { hasResourceAccess, hasResourcePermissions, roles } = usePermissions();
  const {
    user: { isLoaded },
  } = useContext(APIContext);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    const [, section, subSection] = pathname.split('/');
    const resources = Object.values(Resources);
    const currentResource =
      resources.find((resource) => resource === `${section}/${subSection}`) ??
      resources.find((resource) => resource === section);

    if (currentResource && hasResourceAccess(currentResource)) {
      return;
    }

    const hasDashboardAccess = hasResourcePermissions(Resources.Dashboard, [Permission.Read]);
    if (hasDashboardAccess) {
      return redirect(Resources.Dashboard);
    }

    const menuLinks = MENU_LIST.flatMap((menuItem) => {
      if ('resource' in menuItem) {
        return menuItem.resource;
      } else {
        return menuItem.items.map(({ resource }) => resource);
      }
    });

    const firstAccessible = menuLinks.find(
      (link) =>
        hasResourcePermissions(link, [Permission.Full, Permission.Read]) &&
        !roles.some((role) =>
          CUSTOM_ACCESS_RESOURCES_PROHIBITED_ROLES[link as CustomAccessResorces]?.includes(role),
        ),
    );

    if (firstAccessible) {
      redirect(firstAccessible);
    }
  }, [pathname, isLoaded, roles]);
}
